module.exports = __webpack_public_path__ + "img/icon21.92141227.92141227.svg";